import { Button, CircularProgress, TextField, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Label from "../NewItemForm/components/Label";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: { xs: "80%", sm: "50%" },
  maxHeight: "90%",
  overflowY: "auto",
  width: { xs: "90%", md: "40%" },
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "5px",
  margin: "0px 0px",
  p: { xs: 2, md: 5 },
};

interface DuplicateItemModalProps {
  open: boolean;
  close: () => void;
  customStyle?: object;
  sx?: object;
  loading: boolean;
  onSubmit: (values: { name: string }) => void;
  setItemName: React.Dispatch<React.SetStateAction<string>>;
}

const validationSchema = Yup.object({
  name: Yup.string().required("Item name is required"),
});

export default function DuplicateItemModal({
  open,
  close,
  customStyle = {},
  sx = {},
  loading,
  onSubmit,
  setItemName,
}: DuplicateItemModalProps) {
  return (
    <Modal
      open={open}
      onClose={close}
      aria-labelledby="customer-modal-title"
      aria-describedby="customer-modal-description"
      sx={{ ...sx }}
    >
      <Box>
        <Formik
          initialValues={{ name: "" }}
          validationSchema={validationSchema}
          enableReinitialize={true}
          onSubmit={onSubmit}
        >
          {({ errors, touched, setFieldValue }) => {
            const handleChange = (e: React.ChangeEvent<any>) => {
              const { name, value } = e.target;
              setFieldValue(name, value);
              setItemName(value);
            };

            return (
              <Form>
                <Box sx={{ ...style, ...customStyle }}>
                  {/* Modal Title */}
                  <Typography sx={{ fontSize: "22px", fontWeight: "600" }}>
                    Duplicate Item
                  </Typography>

                  <Label label="Name" required={true} />
                  <Field
                    as={TextField}
                    name="name"
                    fullWidth
                    onChange={handleChange}
                    error={touched.name && Boolean(errors.name)}
                  />
                  {errors.name && touched.name && (
                    <Typography color="red" fontSize="12px">
                      {errors.name}
                    </Typography>
                  )}

                  {/* Modal Body */}
                  <Box mt={2}>
                    <Typography sx={{ fontSize: "17px", fontWeight: "400" }}>
                      You can update your new item name now or change it later
                      in Item Edit.
                    </Typography>
                  </Box>

                  {/* Modal Footer */}
                  <Box
                    mt={2}
                    display="flex"
                    justifyContent="flex-end"
                    gap={"10px"}
                  >
                    <Button
                      type="submit"
                      sx={{
                        width: "150px",
                        backgroundColor: "#2E7D32",
                        fontWeight: 600,
                        color: "#FFF",
                        "&:hover": {
                          backgroundColor: "#2E7D32",
                        },
                      }}
                      disabled={loading}
                    >
                      {loading ? (
                        <CircularProgress sx={{ color: "white" }} size={20} />
                      ) : (
                        "Save"
                      )}
                    </Button>

                    <Button
                      variant="outlined"
                      sx={{
                        width: "150px",
                        borderColor: "#000",
                        color: "#000",
                        fontWeight: 600,
                        "&:hover": {
                          borderColor: "#000",
                          backgroundColor: "#f5f5f5",
                        },
                      }}
                      onClick={close}
                    >
                      Cancel
                    </Button>
                  </Box>
                </Box>
              </Form>
            );
          }}
        </Formik>
      </Box>
    </Modal>
  );
}
